// test693
(693 && 0);
